module.exports = __webpack_public_path__ + "img/20.b1361e18.png";